// "Spot the Slip" expansion — BODY & HEALTH theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_BODY_HEALTH = [
  ["La mia amica sta malata questa settimana.", "La mia amica è malata questa settimana.", "essere-stare",
    "Illness is expressed with essere in Italian → è malata.", "essere-vs-stare"],
  ["Dopo aver corso, sto molto stanco.", "Dopo aver corso, sono molto stanco.", "essere-stare",
    "Tiredness uses essere → sono stanco.", "essere-vs-stare"],
  ["Non sono bene, ho mal di testa.", "Non sto bene, ho mal di testa.", "essere-stare",
    "Well-being uses stare → non sto bene.", "essere-vs-stare"],
  ["Mi fa male la ginocchio destro.", "Mi fa male il ginocchio destro.", "gender",
    "Ginocchio is masculine → il ginocchio.", "gender-of-nouns"],
  ["Ho un tosse molto forte.", "Ho una tosse molto forte.", "gender",
    "Tosse is feminine → una tosse.", "gender-of-nouns"],
  ["Ha la gola irritato.", "Ha la gola irritata.", "agreement",
    "Irritata must agree with the feminine gola.", "adjective-agreement"],
  ["Mi fa male i denti la notte.", "Mi fanno male i denti la notte.", "piacere",
    "Fare male works like piacere; plural teeth → fanno male.", "piacere-and-similar-verbs"],
  ["Mi piace i rimedi naturali.", "Mi piacciono i rimedi naturali.", "piacere",
    "Plural remedies liked → piacciono.", "piacere-and-similar-verbs"],
  ["Le medicine sono nel armadietto.", "Le medicine sono nell'armadietto.", "articulated-prep",
    "in + l' before a vowel becomes nell' → nell'armadietto.", "preposition-contractions"],
  ["La ricetta? Il medico ha dato a me ieri.", "La ricetta? Il medico me l'ha data ieri.", "pronoun-order",
    "Combine indirect + direct: me la → me l'ha data.", "object-pronouns"],
  ["L'anno scorso mi rompevo la gamba sciando.", "L'anno scorso mi sono rotto la gamba sciando.", "passato-imperfetto",
    "A single, finished injury takes the passato prossimo → mi sono rotto.", "passato-prossimo-vs-imperfetto"],
  ["Ieri ho stato dal dentista.", "Ieri sono stato dal dentista.", "auxiliary",
    "Essere/stare take essere in compound tenses → sono stato.", "compound-tenses-and-auxiliaries"],
  ["È importante che tu bevi più acqua.", "È importante che tu beva più acqua.", "congiuntivo",
    "Impersonal 'è importante che' takes the subjunctive → beva.", "congiuntivo-presente"],
  ["È meglio che io riposo una settimana.", "È meglio che io riposi una settimana.", "congiuntivo",
    "'È meglio che' triggers the subjunctive → io riposi.", "congiuntivo-presente"],
  ["Mi fa male la testa da stamattina.", "Mi fa male la testa da stamattina.", "piacere",
    "Trap check: singular 'testa' → fa male. (Already correct!)", "piacere-and-similar-verbs"],
];
